import moment from 'moment'
import ApiService from '../services/ApiService'

export const V2_FRONTEND_URL = 'https://neo.fixsystem.io'

const MIGRATION_CHECK_INTERVAL_MS = 5 * 60 * 1000

let lastCheck = { institutionId: null, at: 0 }
let watchersInstalled = false

function isRedirectableUser(user) {
  return !!user && user.mainType != 0 && user.mainType != 1
}

export function shouldRedirectToV2(institution, user) {
  return (
    isRedirectableUser(user) && !!institution && institution.migratedToV2 === true
  )
}

export function redirectToV2(redirectUrl) {
  window.location.href = redirectUrl || V2_FRONTEND_URL
}

export async function checkMigrationAndRedirect(institution, user, force = false) {
  if (!isRedirectableUser(user) || !institution || !institution.id) return false

  if (shouldRedirectToV2(institution, user)) {
    redirectToV2()
    return true
  }

  if (
    !force &&
    lastCheck.institutionId === institution.id &&
    Date.now() - lastCheck.at < MIGRATION_CHECK_INTERVAL_MS
  )
    return false

  lastCheck = { institutionId: institution.id, at: Date.now() }

  try {
    const response = await new ApiService().get(
      `institution/check-migration/${institution.id}`,
      null,
      false,
      false,
    )

    if (response && response.content && response.content.migratedToV2 === true) {
      institution.migratedToV2 = true
      localStorage.setItem('institution', JSON.stringify(institution))
      redirectToV2(response.content.redirectUrl)
      return true
    }
  } catch (err) {}

  return false
}

function hasValidSession() {
  const token = localStorage.getItem('token')
  const expires = localStorage.getItem('expires')

  return !!token && moment().isBefore(moment(expires))
}

async function checkCurrentSession(force) {
  if (!hasValidSession()) return

  try {
    const user = JSON.parse(localStorage.getItem('user'))
    const institution = JSON.parse(localStorage.getItem('institution'))

    await checkMigrationAndRedirect(institution, user, force)
  } catch (err) {}
}

export function installMigrationWatchers() {
  if (watchersInstalled) return
  watchersInstalled = true

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') checkCurrentSession(true)
  })

  window.addEventListener('focus', () => checkCurrentSession(false))

  window.addEventListener('storage', (event) => {
    if (event.key === 'institution') checkCurrentSession(true)
  })
}
